import React, { useEffect, useState } from 'react';
import { ButtonBase, Input, InputAdornment } from '@material-ui/core';
import { ReactComponent as CancelIcon } from '@mediabank/assets/icons/clear-search-text-disabled.svg';
import { ReactComponent as SearchIcon } from '@mediabank/assets/icons/search-magnifier.svg';
import PropTypes from 'prop-types';

import { useInputStyles } from './styles';

const SearchBox = ({ disabled, value, onSearch, children, customClasses, ...rest }) => {
    const [keyword, setKeyword] = useState(value);

    useEffect(() => {
        setKeyword(value);
    }, [value]);

    const clear = () => {
        setKeyword('');
        onSearch('');
    };

    const onChange = e => {
        setKeyword(e.target.value);
    };

    const onKeyUp = e => {
        if (e.key === 'Escape') {
            setKeyword('');
        }

        if (e.key === 'Enter') {
            onSearch(keyword);
        }
    };

    const classes = {
        ...useInputStyles(),
        ...customClasses,
    };

    return (
        <Input
            disabled={disabled}
            {...rest}
            classes={classes}
            disableUnderline={true}
            endAdornment={
                <InputAdornment position="end">
                    {keyword && <CancelIcon className="cancelBtn" data-testid="cancelBtn" onClick={clear} />}
                    {children}
                    <ButtonBase className="textBtn" data-testid="searchBox-icon" onClick={() => onSearch(keyword)}>
                        Search
                    </ButtonBase>
                </InputAdornment>
            }
            fullWidth={true}
            inputProps={{
                'data-testid': 'searchBox-input',
            }}
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon />
                </InputAdornment>
            }
            type="text"
            value={keyword}
            onChange={onChange}
            onKeyUp={onKeyUp}
        />
    );
};

SearchBox.propTypes = {
    disabled: PropTypes.bool,
    onSearch: PropTypes.func.isRequired,
    value: PropTypes.string,
    children: PropTypes.node,
    customClasses: PropTypes.object,
};

SearchBox.defaultProps = {
    disabled: false,
    value: '',
    placeholder: 'Search...',
    children: null,
    customClasses: {},
};

export default SearchBox;
